import { FC } from 'react';
import { Bull } from 'types';
import utils from 'utils';
import { LZView, ObjectView, TableView } from 'components/Avaliations';
import GenericTableCenterChart from '../Proof/GenericTableCenterChart';
import { Stack, Typography } from '@mui/material';

type Props = {
  bull: Bull;
  selectedProof?: any;
  selectedProofData?: [any];
  proofObject?: any;
};

/* leite-zebu component rendering */
const ZLBullDetails: FC<Props> = ({
  selectedProof,
  selectedProofData,
  bull,
  proofObject,
}) => {
  if (
    selectedProof !== ' ' &&
    selectedProofData !== null &&
    utils.segmentFromBullOrBreed(bull) === 'zl'
  ) {
    if (selectedProof.toLowerCase() === 'gir leiteiro') {
      let qntRenderElement: JSX.Element | null = null;
      let profileRenderElement: JSX.Element | null = null;

      selectedProofData?.forEach((proof: any) => {
        if (proof.name.toLowerCase().includes('qt')) {
          qntRenderElement = <p>Qt. Filhas: {proof.values}</p>;
        } else if (
          proof.name.toLowerCase().includes('perfil') &&
          proof.values[0] &&
          typeof proof.values[0] === 'object'
        ) {
          const proofProfile: any = {};
          const regex = /\s\d+$/;
          Object.entries(proof.values[0]).forEach(([ key, value ]) => {
            proofProfile[key.replace(regex, '')] = {
              value: value,
              base: 0,
              max: 3,
              min: -3,
              middle: true,
            };
          });
          profileRenderElement = (
            <GenericTableCenterChart
              data={proofProfile}
              title={'PERFIL LINEAR'}
              key={'PERFIL LINEAR'}
            />
          );
        }
      });
      return (
        <>
          <Stack
            {...utils.stack.flex.col('flex-start', 'center')}
            spacing={2}
            sx={utils.sx.fw}
          >
            <Typography>{selectedProof}</Typography>
          </Stack>
          <div>
            {profileRenderElement}
            {qntRenderElement}
          </div>
        </>
      );
    } else {
      return (
        <>
          <Stack
            {...utils.stack.flex.col('flex-start', 'center')}
            spacing={2}
            sx={utils.sx.fw}
          >
            <Typography>{selectedProof}</Typography>
          </Stack>
          <LZView data={proofObject[selectedProof].table} />
        </>
      );
    }
  }

  return <></>;
};

export default ZLBullDetails;
